import { IntegrationFormZendesk } from 'src/components/Integrations/IntegrationForms/IntegrationFormZendesk/IntegrationFormZendesk';
import { IntegrationFormZendeskChat } from 'src/components/Integrations/IntegrationForms/IntegrationFormZendeskChat/IntegrationFormZendeskChat';
import { IntegrationFormZohoSalesIqChat } from 'src/components/Integrations/IntegrationForms/IntegrationFormZohoSalesIqChat/IntegrationFormZohoSalesIqChat';
import { IntegrationFormZendeskEmail } from 'src/components/Integrations/IntegrationForms/IntegrationFormZendeskEmail/IntegrationFormZendeskEmail';
import { IntegrationFormFreshdeskEmail } from 'src/components/Integrations/IntegrationForms/IntegrationFormFreshdeskEmail/IntegrationFormFreshdeskEmail';
import { IntegrationFormFreshdeskChat } from 'src/components/Integrations/IntegrationForms/IntegrationFormFreshdeskChat/IntegrationFormFreshdeskChat';
import { IntegrationFormSlack } from 'src/components/Integrations/IntegrationForms/IntegrationFormSlack/IntegrationFormSlack';
import { IntegrationFormFreshdesk } from 'src/components/Integrations/IntegrationForms/IntegrationFormFreshdesk/IntegrationFormFreshdesk';
import React from 'react';
import { DialogFooter } from 'src/components/ui/dialog';
import Button from 'src/components/Button/Button';
import { Button as ButtonShad } from 'src/components/ui/button';
import { useTheme } from 'src/provider/ThemeProvider';
import { IntegrationFormZohoEmail } from 'src/components/Integrations/IntegrationForms/IntegrationFormZohoEmail/IntegrationFormZohoEmail';
import { IntegrationFormTrengo } from 'src/components/Integrations/IntegrationForms/IntegrationFormTrengo/IntegrationFormTrengo';
import { useAppSelector } from 'src/store';

const NextIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="9" height="9" viewBox="0 0 9 9" fill="none">
    <path
      d="M0 5.0625L6.84562 5.0625L3.70125 8.20688L4.5 9L9 4.5L4.5 -9.81574e-10L3.70687 0.793125L6.84562 3.9375L0 3.9375V5.0625Z"
      fill="white"
    />
  </svg>
);

export const AddIntegrationSettings = ({
  onSubmit,
  onBackButton,
  isLastStep = false,
  defaultBtnStyle = false,
  close = (..._args: any[]) => {},
}) => {
  const { config } = useTheme();
  const { selectedIntegration } = useAppSelector((s) => s.integrationSlices);

  const renderIntegrationSettingsForm = ({ data }) => {
    switch (data.integration_type) {
      case 'zendesk':
        return <IntegrationFormZendesk integration={data} onSubmit={onSubmit} />;
      case 'zendesk_chat':
        return <IntegrationFormZendeskChat integration={data} onSubmit={onSubmit} />;
      case 'zoho_salesiq':
        return <IntegrationFormZohoSalesIqChat integration={selectedIntegration} close={close} />;
      case 'zoho_desk':
        return <IntegrationFormZohoEmail integration={data} onSubmit={onSubmit} />;
      case 'zendesk_email':
        return <IntegrationFormZendeskEmail onSubmit={onSubmit} />;
      case 'freshdesk_email':
        return <IntegrationFormFreshdeskEmail integration={data} onSubmit={onSubmit} />;
      case 'freshdesk_chat':
        return <IntegrationFormFreshdeskChat integration={data} onSubmit={onSubmit} />;
      case 'slack':
        return <IntegrationFormSlack integration={data} onSubmit={onSubmit} />;
      case 'freshdesk':
        return <IntegrationFormFreshdesk integration={data} onSubmit={onSubmit} />;
      case 'trengo':
        return <IntegrationFormTrengo integration={data} onSubmit={onSubmit} />;
      default:
        return null;
    }
  };

  return (
    <>
      {renderIntegrationSettingsForm(selectedIntegration)}
      <DialogFooter>
        {!defaultBtnStyle ? (
          <>
            <Button
              style={{ width: 'auto', minWidth: '100px' }}
              className="transparent black"
              onClick={selectedIntegration?.id ? close : onBackButton}
            >
              {selectedIntegration?.id ? 'Close' : 'Back'}
            </Button>
            <Button
              style={{ width: 'auto', minWidth: '100px' }}
              type="submit"
              form="integration-form"
              className={config.className}
            >
              {selectedIntegration?.id ? 'Next' : 'Add'}
            </Button>
          </>
        ) : (
          <div className="sticky bottom-0 w-full">
            <div className="flex w-full items-center justify-center gap-2.5 pb-6 pt-5">
              <ButtonShad
                type="button"
                variant="outline"
                className="transparent black min-w-28"
                onClick={
                  selectedIntegration?.id || isLastStep ? () => close(isLastStep) : onBackButton
                }
              >
                {selectedIntegration?.id ? 'Close' : isLastStep ? 'Save & Close' : 'Back'}
              </ButtonShad>
              <ButtonShad type="submit" className="min-w-28" form="integration-form">
                {isLastStep ? (
                  'Launch'
                ) : selectedIntegration?.id ? (
                  <span className={'flex gap-2 items-center'}>
                    Next <NextIcon />
                  </span>
                ) : (
                  'Add'
                )}
              </ButtonShad>
            </div>
          </div>
        )}
      </DialogFooter>
    </>
  );
};
